import loadable from '@loadable/component';


export default loadable(
  () => import(/* webpackChunkName: "user.prive" */ '../layouts/Loyalty'),
);
